import { createSelector } from 'reselect';
import { Map, List } from 'immutable';
import { ProfileSectionType } from 'enums/profile-section-type';

const selectFundingSearchProfile = (state) => state.get('fundingSearchProfile');

const makeSelectProfileLoading = () =>
  createSelector(selectFundingSearchProfile, (state) => state.getIn(['network', 'loading']));
const makeSelectProfileLoadingIntegration = () =>
  createSelector(selectFundingSearchProfile, (state) => state.getIn(['network', 'integration']));

const makeSelectProfileFundingSearchId = () =>
  createSelector(selectFundingSearchProfile, (state) => state.get('fundingSearchId'));

const makeSelectProfileSectionById = () =>
  createSelector(selectFundingSearchProfile, (state) => state.get('byId', Map()));

const makeSelectProfileSectionIds = () =>
  createSelector(selectFundingSearchProfile, (state) => state.get('ids', List()));

const makeSelectProfileSections = () =>
  createSelector(makeSelectProfileSectionById(), makeSelectProfileSectionIds(), (byId, ids) =>
    ids.map((id) => byId.get(id)),
  );

const makeSelectProfileSection = (sectionKey) =>
  createSelector(makeSelectProfileSectionById(), (byId) => byId.get(sectionKey));

const makeSelectProfileShareholders = () =>
  makeSelectProfileSection(ProfileSectionType.significantOwners);

const makeSelectProfileDirectors = () => makeSelectProfileSection(ProfileSectionType.director);

const makeSelectProfileCompanyDetails = () =>
  makeSelectProfileSection(ProfileSectionType.basicCompanyDetails);

const makeSelectProfileCompanyType = () =>
  createSelector(makeSelectProfileSection(ProfileSectionType.basicCompanyDetails), (section) =>
    section.getIn(['data', 'companyType']),
  );

const makeSelectProfileContactName = () =>
  createSelector(makeSelectProfileSection(ProfileSectionType.basicCompanyDetails), (section) =>
    section.getIn(['data', 'contactName']),
  );

export {
  makeSelectProfileFundingSearchId,
  makeSelectProfileLoading,
  makeSelectProfileLoadingIntegration,
  makeSelectProfileSections,
  makeSelectProfileShareholders,
  makeSelectProfileCompanyDetails,
  makeSelectProfileDirectors,
  makeSelectProfileCompanyType,
  makeSelectProfileContactName,
};
